module.exports = __webpack_public_path__ + "img/rw.124d8cb9.png";